<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="done-check.2"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <path id="Path_7995" data-name="Path 7995" d="M0,0H18V18H0Z" fill="none" />
    <path
      id="Path_7996"
      data-name="Path 7996"
      d="M16,6.5,7.75,14.75,4,11"
      transform="translate(-1 -1.625)"
      fill="none"
      :stroke="clr ? clr : '#500fe9'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2.5"
    />
  </svg>
</template>
